export default "__VITE_ASSET__f917c74d__"